import * as React from "react"

import { cn } from "@/lib/utils"
import { useIsReadOnly } from "@/contexts/ReadOnlyContext"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  const inReadOnlyRegion = useIsReadOnly()
  const readOnly = props.readOnly ?? inReadOnlyRegion
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        readOnly && "cursor-default border-transparent bg-muted/50 focus-visible:ring-0 focus-visible:ring-offset-0",
        className
      )}
      ref={ref}
      {...props}
      readOnly={readOnly}
      data-readonly={readOnly || undefined}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }

